import { render, staticRenderFns } from "./TableHistoryPayment.vue?vue&type=template&id=a4205280"
import script from "./TableHistoryPayment.vue?vue&type=script&lang=js"
export * from "./TableHistoryPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports